import React, {useEffect, useMemo, useState} from 'react';

import {observer} from 'mobx-react-lite';
import {appState} from '../../../store/AppStore';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {EmployeesState} from '../../../store/users/employees/EmployeesState';
import {Button, Space, Table} from 'antd';
import {Shell} from '../../../components/Shell';
import {PlusOutlined} from '@ant-design/icons';
import {AppRoutePaths} from '../../../routing/Routes';
import classNames from 'classnames';
import {paginationProps} from '../../serviceActions/utils/ServicesUtils';
import {employeeListColumn} from '../utils/EmployeeTableColumns';

export const EmployeesListView: React.FC = observer((): JSX.Element => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [state] = useState(() => new EmployeesState());
  const data = useMemo(() => state.items, [state.items]);

  useEffect(() => {
    state.loadEmployees();
  }, [state]);
  return (
    <>
      <Shell
        title={t('Employees')}
        actionButtons={[
          <Button
            type="primary"
            key="add"
            size="large"
            icon={<PlusOutlined />}
            onClick={() => navigate(AppRoutePaths.employeeCreate.url)}
            className="shell-btn"
          >
            {t('Add Employee')}
          </Button>,
        ]}
      >
        <Space direction="vertical" className="w-full">
          <Space className={classNames('flex items-end')} />
          <div className="overflow-scroll">
            <Table
              rowKey="id"
              columns={employeeListColumn}
              dataSource={data}
              loading={appState.isLoading}
              pagination={{
                ...paginationProps,
                current: state.pageNumber,
                total: state.total,
                pageSize: state.pageSize,
              }}
              onChange={(pagination, filters) => {
                state.setPagination(pagination);
                state.setFilters(filters);
              }}
            />
          </div>
        </Space>
      </Shell>
    </>
  );
});
